import API from "../../../../app/api";

const handleRequest = async (url) => {
    try {
        const res = await API.get(url);
        return res.data?.data;
    } catch (error) {
        throw error.response?.data?.message || error.message;
    }
};

export const getTopPicks = () =>
    handleRequest("/product-others/top-picks");

export const getAddOns = () =>
    handleRequest("/product-others/add-ons");

export const getMoreLike = () =>
    handleRequest("/product-others/more-like");
